// router.js
import { RouterMount, createRouter } from 'uni-simple-router';
import { pushOnceSubscribeMessage } from '../utils/subscribe';
import queryParams from 'uview-ui/libs/function/queryParams';
import CONFIG from '@/config/index';

const router = createRouter({
  platform: process.env.VUE_APP_PLATFORM,
  routes: [...ROUTES],
});
// 全局路由前置守卫
router.beforeEach((to, from, next) => {
  const { openid, action, template_id, scene } = to.query;
  // 一次性订阅上报
  if (action === 'confirm' && openid && scene && template_id) {
    const youshuParms = ['openid', 'action', 'template_id', 'scene'];
    const newRouterParams = {};
    for (const key in to.query) {
      if (youshuParms.indexOf(key) < 0) {
        newRouterParams[key] = to.query[key];
      }
    }
    const nosubscribeUrl = queryParams(newRouterParams);
    const postData = {
      appId: CONFIG.APPID,
      pageAddress: process.env.VUE_APP_H5_HOST + to.path + nosubscribeUrl,
      openid,
      action,
      template_id,
      scene,
    };
    // 异步请求订阅上报的接口
    pushOnceSubscribeMessage(postData);
    next(to.path + nosubscribeUrl);
    return;
  }
  if (to.path === '/pages/login/login' && !to.query.code && from.path !== '/pages/webView') {
    uni.setStorageSync('loginBackPath', from.fullPath);
  }
  next();
});

export {
  router,
  RouterMount,
};
